import {API_URL, THEME_COLOR} from "../constant"
import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import HeaderBack from "../layout/HeaderBack";
import { useLocalStorage } from "../useLocalStorage";
import M from "materialize-css";
import toast, { Toaster } from 'react-hot-toast';
import Select from 'react-select';
// import { Link } from "react-router-dom";


const Address = ()=>{
    
    let history = useHistory();

    const [token, setToken] = useLocalStorage("token", "");
    const [countries, setCountries] = useState([]);
    const [country, setCountry] = useState(null);
    const [provinces, setProvinces] = useState([]);
    const [province, setProvince] = useState(null);
    const [cities, setCities] = useState([]);
    const [city, setCity] = useState(null);
    const [regencies, setRegencies] = useState([]);
    const [regency, setRegency] = useState(null);
    const [districts, setDistricts] = useState([]);
    const [district, setDistrict] = useState(null);
    const [villages, setVillages] = useState([]);
    const [village, setVillage] = useState(null);
    const [zipCode, setZipCode] = useState("");
    const [name, setName] = useState("");
    const [address, setAddress] = useState("");
    const [mobilePhone, setMobilePhone] = useState("");
    const [isDefault, setIsDefault] = useState(false);
    
    
    async function AddAddress(){
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("x-access-token", token);

        var urlencoded = new URLSearchParams();
        urlencoded.append("CountryID", country.value);
        urlencoded.append("ProvinceID", province.value);
        urlencoded.append("CityID", city.value);
        urlencoded.append("RegencyID", regency.value);
        urlencoded.append("DistrictID", district.value);
        urlencoded.append("VillageID", village.value);
        urlencoded.append("ZipCode", zipCode);
        urlencoded.append("Address", address);
        urlencoded.append("Name", name);
        urlencoded.append("MobilePhone", mobilePhone);
        urlencoded.append("isDefault", isDefault);

        var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/address`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', error))
    }

    async function FormValidation(){
        let valid = true;

        if(!country){
            toast.error("Please Select Country");
            valid=false;
        }
        else if(!province){
            toast.error("Please Select Province");
            valid=false;
        }
        else if(!city){
            toast.error("Please Select City");
            valid=false;
        }
        else if(!regency){
            toast.error("Please Select Regeceny");
            valid=false;
        }
        else if(!district){
            toast.error("Please Select District");
            valid=false;
        }
        else if(!village){
            toast.error("Please Select Village");
            valid=false;
        }
        else if(!zipCode || zipCode == ""){;
            document.getElementById("ZipCode").classList.remove("valid");
            document.getElementById("ZipCode").classList.remove("invalid");
            document.getElementById("ZipCode").classList.add("invalid");
            valid=false;
        }
        else if(!address || address == ""){;
            document.getElementById("Address").classList.remove("valid");
            document.getElementById("Address").classList.remove("invalid");
            document.getElementById("Address").classList.add("invalid");
            valid=false;
        }
        else if(!name || name == ""){;
            document.getElementById("Name").classList.remove("valid");
            document.getElementById("Name").classList.remove("invalid");
            document.getElementById("Name").classList.add("invalid");
            valid=false;
        }
        else if(!mobilePhone || mobilePhone == ""){;
            document.getElementById("MobilePhone").classList.remove("valid");
            document.getElementById("MobilePhone").classList.remove("invalid");
            document.getElementById("MobilePhone").classList.add("invalid");
            valid=false;
        }

        let countvalid = document.getElementsByClassName("invalid").length;
        valid = valid && countvalid === 0;

        return valid;
    }

    async function SubmitHandler(event){
        event.preventDefault();
        let valid = await FormValidation();
        
        if(valid){
            let response = await AddAddress();
            
            if(response.status == 200){
                history.goBack();
            }else{
                toast.error(response.message)
            }
        }
    }

    function getCountry(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/country`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }

    function getProvince(CountryID){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/province/${CountryID.value}`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }

    function getCity(ProvinceID){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/city/${ProvinceID.value}`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }

    function getRegency(CityID){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/regency/${CityID.value}`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }

    function getDistrict(RegencyID){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/district/${RegencyID.value}`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }

    function getVillage(DistrictID){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/village/${DistrictID.value}`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', {}));
    }

    async function changeCountry(CountryID){
        setCountry(CountryID);
        let response = await getProvince(CountryID);
        if(response.status == 200){
            setProvinces(response.data)
        }else{
            setProvinces([])
            setCities([])
            setRegencies([])
            setDistricts([])
            setVillages([])
            setProvince(null)
            setCity(null)
            setRegency(null)
            setDistrict(null)
            setVillage(null)
            toast.error(response.message)
        }
    }

    async function changeProvince(ProvinceID){
        setProvince(ProvinceID)
        let response = await getCity(ProvinceID);
        if(response.status == 200){
            setCities(response.data)
        }else{
            setCities([])
            setRegencies([])
            setDistricts([])
            setVillages([])
            setCity(null)
            setRegency(null)
            setDistrict(null)
            setVillage(null)
            toast.error(response.message)
        }
    }

    async function changeCity(CityID){
        setCity(CityID)
        let response = await getRegency(CityID);
        if(response.status == 200){
            setRegencies(response.data)
        }else{
            setRegencies([])
            setDistricts([])
            setVillages([])
            setRegency(null)
            setDistrict(null)
            setVillage(null)
            toast.error(response.message)
        }
    }

    async function changeRegency(RegencyID){
        setRegency(RegencyID)
        let response = await getDistrict(RegencyID);
        if(response.status == 200){
            setDistricts(response.data)
        }else{
            setDistricts([])
            setVillages([])
            setDistrict(null)
            setVillage(null)
            toast.error(response.message)
        }
    }

    async function changeDistrict(DistrictID){
        setDistrict(DistrictID)
        let response = await getVillage(DistrictID);
        if(response.status == 200){
            setVillages(response.data)
        }else{
            setVillages([])
            setVillage(null)
            toast.error(response.message)
        }
    }

    function changeVillage(VillageID){
        setVillage(VillageID)
        setZipCode(VillageID.ZipCode)
    }

    useEffect(async ()=>{
        var elems = document.querySelectorAll('select');
        var instances = M.FormSelect.init(elems, {});

        let response = await getCountry();
        if(response.status == 200){
            setCountries(response.data)
        }else{
            toast.error(response.message);
        }
    },[])

    return(
        <React.StrictMode>
            <Toaster
                position="bottom-center"
            />
            <HeaderBack title="Address" /> 
            <div className="row" style={{padding:"10px", backgroundColor:"white"}}>
                <form className="col s12">
                    <div className="row">
                        <div className="input-field col s12">
                            <label className="active" htmlFor="Country">Country</label>
                            <Select 
                                name="Country"
                                id="Country"
                                // value = {
                                //     countries.filter(val => 
                                //        val.label === 'Indonesia')
                                //  }
                                onChange = {value => changeCountry(value)}
                                options={countries}
                                placeholder="Country"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s12">
                            <label className="active" htmlFor="Province">Province</label>
                            <Select 
                                name="Province"
                                id="Province"
                                onChange = {value => changeProvince(value)}
                                options={provinces}
                                placeholder="Province"
                                
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s12">
                            <label className="active" htmlFor="City">City</label>
                            <Select 
                                name="City"
                                id="City"
                                onChange = {value => changeCity(value)}
                                options={cities}
                                placeholder="City"
                                
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s12">
                            <label className="active" htmlFor="Regency">Regency</label>
                            <Select 
                                name="Regency"
                                id="Regency"
                                onChange = {value => changeRegency(value)}
                                options={regencies}
                                placeholder="Regency"
                                
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s12">
                            <label className="active" htmlFor="District">District</label>
                            <Select 
                                name="District"
                                id="District"
                                onChange = {value => changeDistrict(value)}
                                options={districts}
                                placeholder="District"
                                
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s12">
                            <label className="active" htmlFor="Village">Village</label>
                            <Select 
                                name="Village"
                                id="Village"
                                onChange = {value => changeVillage(value)}
                                options={villages}
                                placeholder="Village"
                                
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s12">
                            <input placeholder="ZipCode" id="ZipCode" type="text" className="validate" value={zipCode} onChange={e => setZipCode(e.target.value)} required/>
                            <label className="active" htmlFor="ZipCode" data-error="wrong">Zip Code</label>
                            <span className="helper-text" id="ZipCodeValidation" data-error="this field is required" data-success=""></span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s12">
                            <input placeholder="Address" id="Address" type="text" className="validate" value={address} onChange={e => setAddress(e.target.value)} required/>
                            <label className="active" htmlFor="Address" data-error="wrong">Address</label>
                            <span className="helper-text" id="AddressValidation" data-error="this field is required" data-success=""></span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s12">
                            <input placeholder="ex: John Doe" id="Name" type="text" className="input-upper validate" value={name} onChange={e => setName(e.target.value)} required/>
                            <label className="active" htmlFor="Name" data-error="wrong">Full Name</label>
                            <span className="helper-text" id="NameValidation" data-error="this field is required" data-success=""></span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="input-field col s12">
                            <input placeholder="MobilePhone" id="MobilePhone" type="text" className="validate" value={mobilePhone} onChange={e => setMobilePhone(e.target.value)} required/>
                            <label className="active" htmlFor="MobilePhone" data-error="wrong">Mobile Phone</label>
                            <span className="helper-text" id="MobilePhoneValidation" data-error="this field is required" data-success=""></span>
                        </div>
                    </div>
                    <p>
                        <label>
                            <input type="checkbox" class="filled-in" onChange={(e)=> setIsDefault(e.target.checked)} />
                            <span>Set to default</span>
                        </label>
                    </p>

                    <div className="row">
                        <div className="col s12 center">
                            <a className={`btn ${THEME_COLOR}`} onClick={SubmitHandler}><i></i>Register</a>
                        </div>
                    </div>
                </form>
            </div>
        </React.StrictMode>
    );
}

export default Address;
